import React  from 'react';
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { Zoom } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import { useState } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { DetailArticle as ComponentDetailArticle } from "./DetailArticle";
import { ArticleData } from './ArticleData';
import Documentationread from './Documentationread';

export const DetailArticle =  (props) => {
    
const [data, dataSet] = useState([])
const [stafflist, stafflistSet] = useState([])
const [categorylist, categorylistSet] = useState([])
const [article, articleSet] = useState(null)
const [height, heightSet] = useState(null)

  useEffect(() => {
    async function fetchImages() {
        let response = await fetch( process.env.REACT_APP_API_BEYEGROUP + '/images/' + props.article.id)
        response = await response.json()
        dataSet(response)
        
        let content = await fetch(process.env.REACT_APP_API_BEYEGROUP + '/articles/content/' + props.article.id)
        content = await content.json()
        articleSet(content)
    }

    if(props.article.comment == 3){
        async function fetchStaff() {
            let response = await fetch( process.env.REACT_APP_API_BEYEGROUP + '/categories/staff/' + props.article.category.id)
            response = await response.json()
            stafflistSet(response)
        }
        fetchStaff()

        async function fetchCategory() {
            let response = await fetch( process.env.REACT_APP_API_BEYEGROUP + '/categories/' + props.article.category.id)
            response = await response.json()
            let data = [];
            response.map((cat) => {
                cat.articles.map((article) => {
                    data.push(article)
                })
            })
            categorylistSet(data)
        }
        fetchCategory()

    }

    fetchImages()
  }, [])

//   return <div>{JSON.stringify(data)}</div>

    const {t} = useTranslation()
    let proprietes = {
        duration: 1500,
        transitionDuration: 1000,
        infinite: true,
        indicators: true,
        arrows: true,
        autoplay : true
    }
    let localDate = new Date(props.article.createdAt).toDateString()
    let createdAt = new Date(props.article.createdAt).getFullYear() +'-'+ ( new Date(props.article.createdAt).getMonth() + 1)  + '-' + new Date(props.article.createdAt).getDay()  
    
    return(
        <div>
        
            <article className="blog-details">

                <div className="">
                {
                    props?.article?.category?.id == process.env.REACT_APP_ID_DOCUMENTATION ?
                        <img src={ process.env.REACT_APP_BEYEGROUP + "/img/background.png" } alt={ props.article.images.image } className="img-fluid" />
                        :
                        data.length < 2 ?
                            <img src={ props.article.images.image  } alt={ props.article.images.image } className="img-fluid" />
                        :
                            <Zoom scale={0.1} {...proprietes}>
                            {
                                data.map((each, index) => <img key={index}  style={{width: "100%", maxHeight : 800 +"px"}} src={each.image} alt={each.image} />)
                            }
                            </Zoom>
                    }
                    
                </div>

                <h2 className="title"><Link to={"/articles/" + props.article.id}>{ props.article.title }</Link></h2>

                <div className="meta-top">
                    <ul>
                    <li className="d-flex align-items-center"><i className="bi bi-person text-primary"></i> <Link to="#" className='text-dark'>{ props.article.user.name }</Link></li>
                    <li className="d-flex align-items-center"><i className="bi bi-clock text-primary"></i> <Link to="#"  className='text-dark' style={{  fontSize : 11 }}><time dateTime={ createdAt }>{ localDate }</time></Link></li>
                    { props.comment != -1 && (<li className="d-flex align-items-center"><i className="bi bi-chat-dots text-primary"></i> <Link to={"/articles/" + props.article.id } >{ props.comment > 1 ? props.comment + " Commentaires" : props.comment +" Commentaire" } </Link></li>)}
                    {
                        props.comment == -1 ?(<>
                            <li className="d-flex align-items-center"><i className= { props.article?.user.city ? "bi bi-flag text-primary" : ""}></i> <Link to="#"  className='text-dark' style={{  fontSize : 11 }}>{ props.article?.user.region } { props.article?.user.city }</Link></li>
                            <li className="d-flex align-items-center"><i className={ props.article?.user.email ? "bi bi-envelope text-primary" : ""}></i> <a href={"mailto:" + props.article?.user.email}  className='text-dark' style={{  fontSize : 11 }}>{ props.article?.user.email }</a></li>
                         </>):(
                            props.article.region || props.article.city && (<li className="d-flex align-items-center"><i className="bi bi-flag text-primary"></i> <Link to="#"  className='text-dark'style={{  fontSize : 11 }}>{ props.article?.region } { props.article?.city }</Link></li>)
                        )
                    }
                    <li className="d-flex align-items-center"><i className="bi bi-eye text-danger"></i> <Link to="#" className='text-danger'>{ props.article.view} vues</Link></li>
                    </ul>
                </div>

                <div className="content">
                {/* <div className="content" style={{ height : height ? null : 200+'px', overflow : 'hidden', borderBottom : '2px red'}}> */}
                    <div dangerouslySetInnerHTML={{ __html: article?.content }} />
                    {
                        (props?.article?.category?.id == process.env.REACT_APP_ID_DOCUMENTATION ) && (
                            <Documentationread filePdf={props?.article?.images?.image} />
                        )
                    }
                </div>
 
                <div className={ props.comment == -1 ? "d-none" : "meta-bottom" }>
                    <i className="bi bi-tags"></i>
                    <ul className="cats">
                        <li><Link to={"/categories/" + props.article.category.id }>{ props.article.category.name} </Link></li>
                    </ul>

                    <i className="bi bi-folder"></i>
                    <ul className="tags">
                    {
                        props.categories?.filter(val => val.id != process.env.REACT_APP_ID_DOCUMENTATION)?.map((category) => {
                            return(
                                <li key={ category.id }><Link to={"/categories/" + category.id } >{ category.name }</Link></li>
                            )
                        })
                    }
                    {
                        props.article.comment == 1 &&(
                            <li><Link to={"#/articles/" + props.article.id} onClick={() => heightSet(!height)} className="buy-btn text-dager"><i className="bi bi-files text-dager"></i> Lire plus</Link></li>
                        )
                    }
                    </ul>
                </div>

            </article>
             
            
            {
                props.article.comment == 3 && (
                <div className='mt-5 row'>

                    { 
                        categorylist.length > 0  && (
                            <div className="posts-list row">
                                <ArticleData articles={ categorylist } />
                            </div>
                        )

                    }

                    <div className={stafflist.length > 0 ? "font-monospace my-5 text-center" : "d-none"}>
                        { props.article?.category?.description }
                        <h4 className='h4 mx-3 text-center text-primary bolder font-bolder'>Idée sur l'équipe</h4>
                    </div>

                    
                    {
                        stafflist.map( article => {
                            return(
                                <div className='col-md-6'>
                                    <ComponentDetailArticle   article={ article } comment={ -1 } categories={ [] } />
                                </div>
                            )
                        })
                    }
                </div>
                )
            }
        </div>
    )

}
